var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('el-backtop',[_c('div',{staticClass:"app-backtop"},[_c('img',{staticClass:"app-backtop-img",attrs:{"src":require("./assets/image/version1/backTop.png")}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }